import { HttpResult } from "widgets-for-react";
import { CasePageData } from "../../sharepointPageApi/types/pageData";
import { AllCases } from "./allCasesBlockState";

export const allCasesBlockApi = async (): Promise<HttpResult<AllCases>> => {
    const res = await fetch(`/api/v1/pages/cases`);

    if (!res.ok)
      return {
        kind: 'failed',
        status: res.status,
      }

    const data: CasePageData[] = await res.json();

    return {
      kind: 'result',
      status: 200,
      value: data,
    };
  }
